<template>
  <!-- 点标记dialog -->
  <v-dialog v-model="value" max-width="700" scrollable persistent>
    <v-card>
      <v-card-title>标记点: {{name}}
        <v-spacer />
        <v-icon color="primary" class="mr-2" @click="$emit('input',false)">mdi-close</v-icon>
      </v-card-title>
      <v-card-text class="pb-8">
        <int-editor label="大小(像素)" v-model="radius"></int-editor>
        <color-editor label="颜色" v-model="fillColor"></color-editor>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" @click="onOk">确定</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: ['value', 'point'],
  watch: {
    value (v) {
      if (v) {
        this.name = this.point.name;
        this.radius = this.point.marker ? this.point.marker.radius : this.point.radius;
        this.fillColor = this.point.color;
      }
    }
  },
  data () {
    return {
      name: null,
      radius: null,
      fillColor: null
    }
  },
  methods: {
    onOk () {
      this.$parent.onUpdatePoint(this.radius, this.fillColor);
    }
  }
}
</script>